import { render, staticRenderFns } from "./GeneralDashboard.vue?vue&type=template&id=29f663d6"
import script from "./GeneralDashboard.vue?vue&type=script&lang=js"
export * from "./GeneralDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports